const MAIN_FRAMES = {
  DASHBOARD: 'Dashboard',
  INSIGHT_DETAIL: 'Insight Detail',
} as const;

export const AIOPS_FRAME_NAMES = {
  INSIGHT_DETAIL: {
    ISSUE_SUMMARY: `${MAIN_FRAMES.INSIGHT_DETAIL}/Anomaly Detection Metrics`,
    CAUSE_TYPE: `${MAIN_FRAMES.INSIGHT_DETAIL}/Cause Type`,
  },
} as const;
